module.exports = __webpack_public_path__ + "img/referafriendsmall.51256479.png";